<script setup lang="ts">
import { cn } from '@/utils';
import { skeletonVariants, type SkeletonProps } from '.';

const props = defineProps<SkeletonProps>();
const activeClasses = computed(() =>
	cn(skeletonVariants({ variant: props.variant }), props.class)
);
</script>

<template>
	<div :class="props.isActive ? activeClasses : props.class">
		<slot v-if="!props.isActive || props.onlySkeleton" />
	</div>
</template>
